export const getMapCoordinates = (value: number, percent: number) =>
  value * (percent / 100)
